<template lang="pug">
.comment
  .comment-thumb
    h5 {{ `${firstName[0]}${lastName[0]}` }}
  .comment-body
    h5 {{ `${firstName} ${lastName}` }}
    p {{ body }}
</template>

<style lang="stylus">
.comment
  display: flex
  margin-right: unitRes(-10, -20)
  margin-left: unitRes(-10, -20)

  &-thumb
    width: unitRes(50, 80)
    height: unitRes(50, 80)
    flex: 0 0 unitRes(50, 80)
    overflow: hidden
    border-radius: 20em
    background: $clBlack
    margin: 0 unitRes(10, 20)
    color: $clWhite
    display: flex
    align-items: center
    justify-content: center

    h5
      margin: 0

  &-body
    margin: 0 unitRes(10, 20)
</style>

<script>
export default {
  name: 'Comment',
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    }
  }
};
</script>
